const STORAGE_KEY = "shobdo.access_token";

export const getToken = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Private-mode or storage full — fall through; next request will 401 and redirect.
  }
};

export const clearToken = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
};
